angular.module('rjmNg.services').factory 'colorThemeService', [
  "app"
  "Users"
  "colorThemeConstants"
  (
    app
    Users
    colorThemeConstants
  ) ->

    _colorThemeId = app.getColorThemeId()

    getColors = (colorThemeId = null) ->
      if colorThemeId?
        return colorThemeConstants.THEMES[colorThemeId]
      else
        return colorThemeConstants.THEMES[_colorThemeId]

    pickColorForScatterplotTypeSeries = (orderNumber, colorThemeId = null) ->
      return pickColor(orderNumber, colorThemeId) + "50"

    pickColor = (orderNumber, colorThemeId = null) ->
      colors = getColors(colorThemeId)
      return colors[orderNumber%colors.length]

    saveColorTheme = (userId, colorThemeId) ->
      userPropertiesDeferred = Users.updateProperties(
        userId
        {color_theme_id: colorThemeId}
      ).then () ->
        _colorThemeId = colorThemeId
      return userPropertiesDeferred

    {
      getColors
      pickColorForScatterplotTypeSeries
      pickColor
      saveColorTheme
    }
  ]
